<template>
<div v-if="posts.length>0" class="similar">
    <h2>
      Similar posts
  </h2>
  <div class="similar__posts">
      <template v-for="post of posts">
        <post-card  :post="post" :key="post._id" v-if="post"></post-card>
      </template>
  </div>
</div>
  
</template>

<script>

import PostCard from '@/components/community/PostCard';
import { onMounted, ref, watch } from '@vue/runtime-core';
import axios from 'axios';


export default {
    components:{
        PostCard
    },
    props:['postId'],
    setup(props){

        const posts = ref([]);
        onMounted(() => {
            getSimilarPosts();
        })

        watch(() => props.postId, (id) => {
            getSimilarPosts();
        })

        const getSimilarPosts = async () => {
            const idPost = props.postId;

            try{
                const res = await axios({
                    method: "GET",
                    url:'posts/similar/'+idPost
                })
                posts.value = res.data.data.posts;
            }catch(err){
                console.log(err);
                console.log(err.response);
            }

        }

        return {
            posts
        };
    }
}
</script>

<style lang="scss">

.similar{
    border-top: 1px solid currentColor;
    padding: 4rem 0;
    margin: 4rem 0;
    &:empty{
        margin: 0;
    }

    & h2{
        font-size: 2rem;
        text-transform: uppercase;
        letter-spacing: .2rem;
        margin-bottom: 1.8rem;
    }
}
</style>